import type { Frame } from '@/types'

export const FRAMES: Array<Frame> = [
    {
        id: 'meadow-boulders',
        title: 'Meadow, Late Light',
        location: 'Val Ferret',
        year: '2023',
        camera: 'Phase One XT',
        settings: '32mm · ƒ/8 · 1/250 · ISO 50',
        series: 'High Ground',
        focus: '50% 42%',
        image: '/images/work/01.jpg',
        caption: 'Daisies and purple lupin running down a meadow to a scatter of granite boulders, with a snow face standing over the valley and the last warm light lying along the grass.'
    },
    {
        id: 'road-under-stars',
        title: 'Road Under Stars',
        location: 'Bardenas Reales',
        year: '2024',
        camera: 'Sony A7R V',
        settings: '24mm · ƒ/1.8 · 15s · ISO 3200',
        series: 'Night Work',
        focus: '50% 60%',
        image: '/images/work/02.jpg',
        caption: 'A single road running dead straight into the horizon, with the last pink band of sunset sitting on the fields and the whole arm of the Milky Way already up above it.'
    },
    {
        id: 'rainbow-foot',
        title: 'The Foot of It',
        location: 'County Clare',
        year: '2022',
        camera: 'Hasselblad 907X',
        settings: '45mm · ƒ/5.6 · 1/320 · ISO 100',
        series: 'Weather',
        focus: '50% 55%',
        image: '/images/work/03.jpg',
        caption: 'A double rainbow coming down into a green field, the outer arc faint and reversed, and a bank of daisies in the near grass holding still long enough to be sharp.'
    },
    {
        id: 'open-plain',
        title: 'Open Plain',
        location: 'Alberta Foothills',
        year: '2023',
        camera: 'Phase One XT',
        settings: '55mm · ƒ/11 · 1/400 · ISO 50',
        series: 'Distance Study',
        focus: '50% 45%',
        image: '/images/work/04.jpg',
        caption: 'Dry gold grassland folding away in low ridges until it gives out at a flat blue horizon, with a line of cumulus stacked up over it and sage scattered through the near field.'
    },
    {
        id: 'creek-reeds',
        title: 'Creek, Reeds',
        location: 'Owens Valley',
        year: '2024',
        camera: 'Mamiya 7 · Portra 400',
        settings: '80mm · ƒ/8 · 1/250',
        series: 'Water Table',
        focus: '50% 55%',
        image: '/images/work/05.jpg',
        caption: 'A slow creek cutting through pale reeds toward a snow-topped range, shot on film so the sky goes flat and chalky and the water holds almost no colour at all.'
    },
    {
        id: 'two-running',
        title: 'Two Running',
        location: 'South Downs',
        year: '2024',
        camera: 'Sony A7R V',
        settings: '135mm · ƒ/4 · 1/1000 · ISO 200',
        series: 'Weather',
        focus: '50% 52%',
        image: '/images/work/06.jpg',
        caption: 'Two people running the crest of a field against a sky going orange, small enough in the frame that the picture is really about the ridge line and the light behind it.'
    },
    {
        id: 'lichen-boulders',
        title: 'Lichen and Snow',
        location: 'Columbia Gorge',
        year: '2022',
        camera: 'Phase One XT',
        settings: '110mm · ƒ/9 · 1/500 · ISO 50',
        series: 'High Ground',
        focus: '50% 68%',
        image: '/images/work/07.jpg',
        caption: 'Orange lichen on broken rock in a field of dry grass, with a snow-capped volcano sitting clean above the blue ridges behind and a scatter of flat cloud between them.'
    },
    {
        id: 'turquoise-tarn',
        title: 'Turquoise Tarn',
        location: 'Purcell Range',
        year: '2023',
        camera: 'Hasselblad 907X',
        settings: '38mm · ƒ/11 · 1/200 · ISO 64',
        series: 'High Ground',
        focus: '50% 48%',
        image: '/images/work/08.jpg',
        caption: 'A footpath of loose stone dropping through fireweed to a lake the colour of glacier flour, with a grey horn of rock standing straight up out of the scree behind it.'
    },
    {
        id: 'green-swell',
        title: 'Green Swell',
        location: 'Val d Orcia',
        year: '2021',
        camera: 'Phase One XT',
        settings: '70mm · ƒ/8 · 1/320 · ISO 50',
        series: 'Distance Study',
        focus: '50% 48%',
        image: '/images/work/09.jpg',
        caption: 'Hills rolling away in long green swells with the light raking across them, a heavy grey ceiling of cloud above, and a break in it letting one band of sun onto the far ranges.'
    },
    {
        id: 'coast-road',
        title: 'Coast Road',
        location: 'Northern Headlands',
        year: '2024',
        camera: 'DJI Mavic 3 Pro',
        settings: '24mm · ƒ/5.6 · 1/320 · ISO 100',
        series: 'From Above',
        focus: '50% 45%',
        image: '/images/work/10.jpg',
        caption: 'A road cut into the headland above a rock shelf, a scatter of roofs where the green runs out, and a flat pink sea taking the first of the morning before any wind gets to it.'
    },
    {
        id: 'moon-over-cone',
        title: 'Moon, Rising Cone',
        location: 'Cascade Divide',
        year: '2024',
        camera: 'Phase One XT',
        settings: '150mm · ƒ/8 · 1/125 · ISO 100',
        series: 'Night Work',
        focus: '50% 26%',
        image: '/images/work/11.jpg',
        caption: 'A full moon sitting above a snow cone still holding the last pink of the day, with the ridges below going flat and blue and a bank of fireweed across the whole foreground.'
    }
]
